const initialState = {
  userDetails: null,
  currentDate: localStorage.getItem('date'),
  setting: {
    date: localStorage.getItem('date'),
    isGameLocked: false,
  },
  teamSalaryCap: 0,
  notificationCount: 0,
}

const userReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case 'SET_USER_DETAILS': {
      return {
        ...state,
        userDetails: payload?.user,
        currentDate: payload?.setting?.date,
        setting: {
          ...state?.setting,
          date: payload?.setting?.date,
          isGameLocked: payload?.setting?.isGameLocked,
          season: payload?.setting?.season,
        },
        teamSalaryCap: payload?.teamSalaryCap,
        record: payload?.record,
        notificationCount: payload?.notiCount,
        auctionCount: payload?.liveAuctionCount
      }
    }
    case 'UPDATE_DATE': {
      return {
        ...state,
        setting: {
          ...state?.setting,
          date: payload,
        },
      }
    }
    case 'SET_NOTIFICATION_COUNT': {
      return {
        ...state,
        notificationCount: payload,
      }
    }
    default:
      return state
  }
}

export default userReducer
